import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSessionService } from './auth-session.service';

/** Protege rutas del dashboard; redirige al login o cambio de contraseña según sesión. */
export const authGuard: CanActivateFn = () => {
  const session = inject(AuthSessionService);
  const router = inject(Router);

  // Comentario: sin JWT activo se envía al login.
  if (!session.isAuthenticated()) {
    return router.createUrlTree(['/authentication/login']);
  }

  // Comentario: sesión con contraseña temporal debe completar el cambio primero.
  if (session.requiresPasswordReset()) {
    return router.createUrlTree(['/authentication/cambio-password']);
  }

  return true;
};

/** Permite acceso solo a usuarios autenticados que deben cambiar contraseña. */
export const passwordResetGuard: CanActivateFn = () => {
  const session = inject(AuthSessionService);
  const router = inject(Router);

  if (!session.isAuthenticated()) {
    return router.createUrlTree(['/authentication/login']);
  }

  // Comentario: si ya no requiere cambio, envía al dashboard.
  if (!session.requiresPasswordReset()) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
